var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.resolvedComponent,_vm._g({key:_vm.resolvedComponent,ref:"componentResolved",tag:"component"},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }